import { ERROR_MESSAGES, SYSTEM_DEFAULTS, HTTP, TIME_FORMAT_OPTIONS } from './constants'
export default class HelperFunction {
    static formatCurrency (amount) {
        if (amount === null || amount === undefined || isNaN(amount)) {
            return 0
        }
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'KES',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(Math.abs(amount));
    }
    static getStatusBadge (status) {
        const statusClasses = {
          'completed': 'status-completed',
          'processing': 'status-pending',
          'pending': 'status-pending',
          'failed': 'status-failed'
        };
        return <span className={`status-badge ${statusClasses[status]}`}>{status}</span>;
    };
    static getFetchObj (url, method = HTTP.METHODS.GET_METHOD, body = null) {
        try {
            const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));
            if (!storedUser) {
                throw new Error(ERROR_MESSAGES.MISSING_USER_ID);
            }

            const payload = {
                method,
                headers: {
                    [HTTP.HEADERS.CONTENT_TYPE]: HTTP.HEADERS.APPLICATION_JSON_CONTENT_TYPE,
                    'Authorization': `Bearer ${localStorage.getItem(SYSTEM_DEFAULTS.ACCESS_TOKEN)}`,
                }
            }
            if(method === HTTP.METHODS.POST_METHOD || method === HTTP.METHODS.PUT_METHOD) {
                payload['body'] = JSON.stringify(body)
            }
            return fetch(
                url,
                payload
            );
        } catch(err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }
    static getUnauthFetchObj (url, method = HTTP.METHODS.GET_METHOD, body = null) {
        try {
            const payload = {
                method,
                headers: {
                    [HTTP.HEADERS.CONTENT_TYPE]: HTTP.HEADERS.APPLICATION_JSON_CONTENT_TYPE,
                } 
            }
            if(method === HTTP.METHODS.POST_METHOD || method === HTTP.METHODS.PUT_METHOD){ payload['body'] = JSON.stringify(body) }

            return fetch(
                url,
                payload
            );
        } catch(err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }
    static getPercent (num, denom) {
        if (
            num === null || 
            denom === null || 
            num === undefined || 
            denom === undefined || 
            denom === 0 ||
            isNaN(num) ||
            isNaN(denom)
        ) return 0
        return ((num/denom) * 100).toFixed(2)
    }

    static getPackageDetails(data, key) {
        const { packages } = data
        for (let plan of packages) {
            if(plan.name === key){
                return plan
            }
        }
        return {
            id: null, 
            name: key, 
            total_sum: 0, 
            target_sum: 0
        }
    }

    static totalPackages (data) {
        const { packages } = data
        var total = 0;
        var target = 0;
        for (let plan of packages) {
            total += parseFloat(plan.total_sum)
            target += parseFloat(plan.target_sum)
        }
        return { total, target }
    }

    static getTransactionTotals (data) {
        var total = 0
        for (let item of data) {
            total += parseFloat(item.total_amount)
        }
        return total
    }

    static getTotolsRelativeToMax (data) {
        const totals = data.map(number => { return number.total_amount });
        const maxTotal = Math.max(...totals)
        const formatedTotals = []
        for (let item of totals) {
            formatedTotals.push(((parseFloat(item) * 100) / maxTotal) * 2)
        }
        return formatedTotals
    }

    static formatDate (timestamp, options) {
        const date = new Date(timestamp);
        return date.toLocaleString("en-GB", options);
    }

    static formatDateTime (timestamp) {
        const date = new Date(timestamp);

        // Format options
        const options =  TIME_FORMAT_OPTIONS.DATE_TIME_OPTIONS

        const formatted = date.toLocaleString("en-GB", options);

        // Add suffix to the day (1st, 2nd, 3rd, etc.)
        function getDaySuffix(day) {
            if (day >= 11 && day <= 13) return "th";
                switch (day % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
        }

        const day = date.getUTCDate();
        const withSuffix = `${day}${getDaySuffix(day)}`;
        return formatted.replace(/^\d+/, withSuffix).replace(",", " ");
    }

    static getSavingPlansTransactions (data) {
        const { savingPlans } = data
        let transactions = []
        for (let plan of savingPlans) {
            transactions.push(...plan.transactions);
        }
        return transactions
    }

    static truncateString(str, maxLength = 18, ending = '...') {
        if(str === undefined || str === null) {
            return null
        }
        if (str.length > maxLength) {
          return str.slice(0, maxLength) + ending;
        } else {
          return str;
        }
    }
}